import React from "react";
import Modal from "react-bootstrap/Modal";
import FormLoader from "swfrontend/MDM/MDMScreens/FormView/FormLoader";

export default class ProgressModal extends React.Component {
    render() {
        return (
            <Modal show={this.props.showProgress} centered>
                <Modal.Body>
                    <FormLoader source={"Modal"} loading={true} />
                    <p style={{ textAlign: "center", fontWeight: "bold", fontSize: "18px" }}>
                        {"Loading, Please wait.."}
                    </p>
                </Modal.Body>
            </Modal>
        )
    }
}